<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>Special Orders</h1>
          <v-btn
            class="mx-2"
            fab
            small
            dark
            color="success"
            @click="create"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn color="info" class="mx-2" @click="()=>{this.$router.push({path: '/specialOrders/bySupplier/NEW'})}">By Supplier</v-btn>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
            <v-data-table
              :headers="headers"
              :items="data"
              :options.sync="options"
              :server-items-length="pagination.dataCount"
              :loading="pagination.loading"
              :items-per-page="30"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: pagination.pageSizeOptions
              }"
              @click:row="rowClick"

            >
              <template v-slot:item.status="{ item }">
                <span>{{helpers.parseSpecialOrderStatus(item.status)}}</span>
              </template>
              <template v-slot:item.noItems="{ item }">
                <span v-if="item.metadata && item.metadata.softItems">{{item.metadata.softItems.length}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.dueAt="{ item }">
                <span>{{helpers.customFormatDate(item.dueAt, 'notime')}}</span>
              </template>
              <template v-slot:item.customerName="{ item }">
                <span v-if="item.Customer">{{item.Customer.firstName}} {{item.Customer.lastName}}</span>
                <span v-else>-</span>
              </template>
            </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from "vuex"
  import moment from "moment";
  import helpers from '../../plugins/helpers';
  export default {
    data () {
      return {
        helpers: helpers,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: "ID", align: "start", sortable: true, value: "id"},
          { text: 'Name', value: 'customerName' },
          { text: 'Wedding Date', value: 'dueAt' },
          { text: '# of Items', value: 'noItems' },
          { text: 'Status', value: 'status' },
        ],
        pagination: {
          loading: false,
          dataCount: 0,
          pageSizeOptions: [5, 10, 15, 30, -1]
        },
        options: {
          search: "",
          sortBy: ['id'],
          sortDesc: [false],
          page: 1,
          itemsPerPage: 30
        },
        updatingRoute: false,
        init: false,
        manualRoute: false,

        editMode: false,
        data: [],
        bySupplierData: [],
        singular: "SpecialOrder",
        singularLower: "specialOrder",
        plural: "SpecialOrders",
        pluralLower: "specialOrders"
      }
    },
    async created() {
      try {
        //used for pagination
        let oldQuery = this.getURLQuery();
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || 30
        this.options.sortBy = [oldQuery.sort || "id"]
        this.options.sortDesc = [oldQuery.order || false]
        //used for pagination end
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    watch: {
      options: {
        async handler () {
          if(this.init) return;
          await this.getAllData();
        },
        deep: true,
      },
      $route: {
        handler: async function (current) {
          //used for pagination
          if (this.updatingRoute || this.manualRoute) return;
          let oldQuery = this.getURLQuery(current.query);
          this.options.page = oldQuery.page || 1;
          this.options.itemsPerPage = oldQuery.limit || 30
          this.options.sortBy = [oldQuery.sort || "firstName"]
          this.options.sortDesc = [oldQuery.order || false]
          //used for pagination end include full watcher
          await this.getAllData();
        },
        deep: true
      },
    },
    async mounted(){
        try {
          this.init = true;
          this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;
          await this.getAllData()
          this.init = false;
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getToken', 'isAllowed', 'getEndpoint', 'getGlobalValue'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      getURLQuery(custom=null){
        let oldQuery = custom? {...custom}: {...this.$route.query};
        if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
        if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
        if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
        return oldQuery;
      },
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      async getAllData(){
        try {
          //used for pagination
          this.pagination.loading = true;
          let paginationData = {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sort: (this.options.sortBy.length>0)?this.options.sortBy[0]:"id",
            order: this.options.sortDesc[0],
          }


          let uriFields = Object.keys(paginationData).map(x => {
            return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
          }).join("&");
          //used for pagination end

          let res = await axios.get(`${this.getEndpoint}/api/specialOrders/tableDataPaginated?${uriFields}`)
          if(res.data.error) throw res.data.error;
          this.data = res.data.data
          //used for pagination
          this.pagination.dataCount = res.data.total

          let shouldUpdate = false;
          let oldQuery = this.getURLQuery();
          let newQuery = {...paginationData};

          console.log(oldQuery,newQuery)
          if(Object.keys(newQuery).length!==Object.keys(oldQuery).length) shouldUpdate = true;
          if(!shouldUpdate){
            for(let key of Object.keys(newQuery)){
              if(shouldUpdate) break;

              if(Array.isArray(newQuery[key])){
                if(newQuery[key].length!==oldQuery[key].length){
                  shouldUpdate = true;
                  break;
                }
                for(let i=0;i<newQuery[key].length-1;i++){
                  if(newQuery[key][i]!==oldQuery[key][i]){
                    shouldUpdate = true;
                    break;
                  }
                }
              }
              else if(newQuery[key]!==oldQuery[key]){
                shouldUpdate = true;
              }
            }
          }

          if(shouldUpdate){
            this.updatingRoute = true;
            if(this.init){
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
            }
            else{
              if(this.$route.path===`/${this.pluralLower}`) await this.$router.push({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
            }
            this.updatingRoute = false;
          }
          //used for pagination end

        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.pagination.loading = false;
        }
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders`)
          console.log(res.data)
          if(res.data.error) throw res.data.error
          if(res.data){
            this.$router.push({ path: `/${this.pluralLower}/view/${res.data.id}`})
          }
        } catch (error) {
          console.log(error)
        }
      },
      momentDateFormat (date) {
        return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
      },
      parseISODate(date){
        return (date?new Date(date).toISOString().substring(0, 10):null);
      },
    }
  }
</script>
